import styled from 'styled-components';
import { IStyledBgContainer } from './Content.interface';

export const StyledBgContainer = styled('div')<IStyledBgContainer>(
  ({ bgColor }) => ({
    backgroundColor: bgColor,
  }),
);
